import React from 'react';
import ProductList from './Products/productList';

export default function ProductsListing() {
    return(
        <ProductList />
    )
}